var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedBooking
    ? _c(
        "div",
        {
          staticClass: "ui modal zw transitionstyle",
          class: _vm.tabs.length > 6 ? "fullscreen" : "large"
        },
        [
          _c(
            "div",
            { staticClass: "ui seven top attached zw small steps" },
            _vm._l(_vm.tabs, function(tab, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "step",
                  class: { active: _vm.currentTab === index },
                  attrs: { id: tab.name },
                  on: {
                    click: function($event) {
                      return _vm.switchTab(index)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "icon", class: tab.icon }),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(tab.title))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _vm._v(_vm._s(tab.description))
                    ])
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.tabs[_vm.currentTab].name === "product"
            ? _c("div", { staticClass: "ui active basic tab segment" }, [
                _c("div", { staticClass: "content" }, [
                  _c("h3", { staticClass: "ui header" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.selectedBooking.product.name) +
                        "\n        "
                    ),
                    _c("div", {
                      staticClass: "ui sub header",
                      domProps: {
                        innerHTML: _vm._s(_vm.selectedBooking.product.intro)
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui divider" }),
                  _vm._v(" "),
                  _c("h4", { staticClass: "ui header" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "modals.newbookingmodal.product.content.description"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "description",
                    domProps: {
                      innerHTML: _vm._s(_vm.selectedBooking.product.description)
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.tabs[_vm.currentTab].name === "time"
            ? _c("div", { staticClass: "ui active basic tab segment" }, [
                _c("div", { staticClass: "content" }, [
                  _c("div", { staticClass: "ui two column stackable grid" }, [
                    _c(
                      "div",
                      { staticClass: "eight wide column zw" },
                      [
                        _c("flat-pickr", {
                          ref: "flatpicker",
                          attrs: {
                            config: _vm.booking.flatPickr.config,
                            events: [
                              "onMonthChange",
                              "onYearChange",
                              "onChange",
                              "onReady"
                            ]
                          },
                          on: {
                            "on-month-change": _vm.fetchDates,
                            "on-year-change": _vm.fetchDates,
                            "on-change": _vm.fetchTimes,
                            "on-ready": _vm.fetchDates
                          },
                          model: {
                            value: _vm.booking.selectedDate,
                            callback: function($$v) {
                              _vm.$set(_vm.booking, "selectedDate", $$v)
                            },
                            expression: "booking.selectedDate"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "eight wide column" }, [
                      _c("div", { staticClass: "ui segment zw-fluid" }, [
                        _vm.booking.selectableTimes.length
                          ? _c(
                              "div",
                              { staticClass: "ui divided pickable segments" },
                              _vm._l(_vm.booking.selectableTimes, function(
                                time,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "ui zw center aligned segment",
                                    class: {
                                      selected:
                                        _vm.booking.selectedStartTime ===
                                          time.startTime &&
                                        _vm.booking.selectedEndTime ===
                                          time.endTime,
                                      disabled:
                                        _vm.booking.selectedStartTime ===
                                          time.startTime &&
                                        _vm.booking.selectedEndTime ===
                                          time.endTime &&
                                        !_vm.isTimeAvailable
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectTime(
                                          time.startTime,
                                          time.endTime
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "h2",
                                      { staticClass: "zw compact header" },
                                      [
                                        _vm._v(
                                          _vm._s(time.startTime) +
                                            " - " +
                                            _vm._s(time.endTime)
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.isTimeAvailable
                                      ? _c(
                                          "div",
                                          { staticClass: "zw selection icon" },
                                          [
                                            _c("i", {
                                              staticClass: "checkmark icon"
                                            })
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "zw selection icon disabled"
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "close icon"
                                            })
                                          ]
                                        )
                                  ]
                                )
                              }),
                              0
                            )
                          : _c(
                              "div",
                              { staticClass: "ui inverted dimmer active" },
                              [
                                _c("div", { staticClass: "content" }, [
                                  _c("div", { staticClass: "center" }, [
                                    _c(
                                      "h2",
                                      { staticClass: "ui icon header" },
                                      [
                                        _c("i", { staticClass: "wait icon" }),
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "modals.newbookingmodal.time.content.no_time"
                                              )
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ]
                            )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.selectedBooking.multiple &&
                  _vm.booking.selectedStartTime !== null &&
                  _vm.booking.selectedEndTime !== null &&
                  !_vm.isTimeAvailable
                    ? _c("div", { staticClass: "ui grid" }, [
                        _c(
                          "span",
                          {
                            staticClass: "ui header",
                            staticStyle: { color: "red" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "modals.newbookingmodal.time.no_available_slots"
                                )
                              )
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedBooking.multiple &&
                  _vm.booking.selectedStartTime !== null &&
                  _vm.booking.selectedEndTime !== null &&
                  _vm.isTimeAvailable
                    ? _c("div", { staticClass: "ui grid" }, [
                        _c(
                          "span",
                          {
                            staticClass: "ui header",
                            staticStyle: { color: "#2ecc71" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "modals.newbookingmodal.time.available_slots",
                                  { amount: _vm.availableSlots }
                                )
                              )
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.tabs[_vm.currentTab].name === "winter_place"
            ? _c("div", { staticClass: "ui active basic tab segment" }, [
                _c("div", { staticClass: "content" }, [
                  !_vm.selectedWinterPlace && !_vm.existingWinterPlace
                    ? _c("div", [
                        _c("h3", { staticClass: "ui header" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "modals.newbookingmodal.winter_place.title_not_chosen"
                                )
                              ) +
                              "\n        "
                          )
                        ])
                      ])
                    : _vm.existingWinterPlace
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "ui three column stackable grid center aligned"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "twelve wide tablet ten wide computer column"
                              },
                              [
                                _c("div", { staticClass: "ui segments" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "ui zw-orange inverted center aligned segment"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "ui huge header" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "modals.newbookingmodal.winter_place.existing_place.title"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ui center aligned segment"
                                    },
                                    [
                                      _c("div", { staticClass: "ui header" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "modals.newbookingmodal.winter_place.existing_place.text1",
                                                {
                                                  existingWinterPlace:
                                                    _vm.existingWinterPlace
                                                }
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "modals.newbookingmodal.winter_place.existing_place.text2"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ui center aligned segment"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.overwritePlace,
                                            expression: "overwritePlace"
                                          }
                                        ],
                                        ref: "overwriteCheckbox",
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.overwritePlace
                                          )
                                            ? _vm._i(_vm.overwritePlace, null) >
                                              -1
                                            : _vm.overwritePlace
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleCheckboxClick(
                                              $event
                                            )
                                          },
                                          change: function($event) {
                                            var $$a = _vm.overwritePlace,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.overwritePlace = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.overwritePlace = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.overwritePlace = $$c
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "modals.newbookingmodal.winter_place.existing_place.overwrite_checkbox.label"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "modal",
                                        {
                                          attrs: {
                                            active:
                                              _vm.showOverwritePlaceConfirmModal,
                                            title: "Confirmation window"
                                          },
                                          on: {
                                            denymodal: _vm.denyOverwritePlace,
                                            acceptmodal:
                                              _vm.acceptOverwritePlace
                                          }
                                        },
                                        [
                                          _c("h4", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "modals.newbookingmodal.winter_place.existing_place.overwrite_checkbox.modal_text",
                                                  {
                                                    existingWinterPlace:
                                                      _vm.existingWinterPlace
                                                  }
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.selectedWinterPlace
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ui center aligned segment"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "ui header" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "modals.newbookingmodal.winter_place.existing_place.bottom_text"
                                                    )
                                                  ) +
                                                  ": " +
                                                  _vm._s(
                                                    _vm.selectedWinterPlace
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          ]
                        )
                      ])
                    : _c("div", [
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "modals.newbookingmodal.winter_place.title_chosen",
                                { place: _vm.selectedWinterPlace }
                              )
                            )
                          )
                        ])
                      ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui divider" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui" }, [
                    _c("div", { staticClass: "ui header" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "modals.newbookingmodal.winter_place.click_to_open"
                            )
                          ) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "ui primary button",
                        on: {
                          click: function($event) {
                            return _vm.$emit("open-image", {
                              winterPlace: _vm.selectedWinterPlace
                            })
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "modals.newbookingmodal.winter_place.open_image"
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedBooking
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tabs[_vm.currentTab].name === "details",
                      expression: "tabs[currentTab].name === 'details'"
                    }
                  ],
                  staticClass: "ui active basic tab segment"
                },
                [
                  _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "ui header" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "modals.newbookingmodal.details.content.header"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ui divider" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "ui form",
                        attrs: { "data-vv-scope": _vm.details.formScope }
                      },
                      [
                        _vm._l(
                          _vm.chunkProperty(
                            _vm.selectedBooking.product.fields,
                            2
                          ),
                          function(fields, index) {
                            return _vm.selectedBooking.product.fields
                              ? _c(
                                  "div",
                                  { key: index, staticClass: "two fields" },
                                  _vm._l(fields, function(field) {
                                    return field
                                      ? _c("field", {
                                          key: field.id,
                                          attrs: {
                                            field: field,
                                            allowEdit: field.editable,
                                            scope: _vm.details.formScope,
                                            metas: _vm.safeObjectGet(
                                              _vm.updateBooking,
                                              "metas"
                                            ),
                                            "winter-place": _vm.winterPlaceMeta,
                                            transparent: false,
                                            value: _vm.details.fieldValues
                                          },
                                          on: { input: _vm.changeFieldValue }
                                        })
                                      : _vm._e()
                                  }),
                                  1
                                )
                              : _vm._e()
                          }
                        ),
                        _vm._v(" "),
                        _vm.selectedBooking.guest_enabled || _vm.hasGuest
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "guest-option",
                                  class: {
                                    "guest-option--selected": _vm.hasGuest,
                                    "guest-option--locked":
                                      _vm.isGuestOptionLocked,
                                    "guest-option--unavailable":
                                      _vm.guestCapacityUnavailable &&
                                      !_vm.hasGuest
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "guest-option__content" },
                                    [
                                      _vm._m(0),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "guest-option__details"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "guest-option__title"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "modals.newbookingmodal.guest.title"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "modals.newbookingmodal.guest.description"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "guest-option__price"
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "modals.newbookingmodal.guest.sauna_price"
                                                      )
                                                    ) +
                                                    ":\n                    "
                                                ),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("money")(
                                                        _vm.guestProductPrice
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("span", [_vm._v("+")]),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "modals.newbookingmodal.guest.fee"
                                                      )
                                                    ) +
                                                    ":\n                    "
                                                ),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("money")(
                                                        _vm.configuredGuestFee
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "guest-option__price-total"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    (" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "modals.newbookingmodal.guest.additional_cost"
                                                        )
                                                      ) +
                                                      ":\n                    "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("money")(
                                                          _vm.guestOptionPrice
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(
                                                    ")\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ui toggle checkbox guest-option__checkbox"
                                        },
                                        [
                                          _c("input", {
                                            attrs: {
                                              type: "checkbox",
                                              disabled: !_vm.canEditGuest
                                            },
                                            domProps: { checked: _vm.hasGuest },
                                            on: {
                                              change: function($event) {
                                                return _vm.changeGuestValue(
                                                  $event
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "modals.newbookingmodal.guest.label"
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.isGuestOptionLocked
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "guest-option__locked-message"
                                        },
                                        [
                                          _c("i", { staticClass: "lock icon" }),
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "modals.newbookingmodal.guest.locked"
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm.guestCapacityUnavailable
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "guest-option__capacity-message"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "warning sign icon"
                                          }),
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "modals.newbookingmodal.guest.capacity_unavailable"
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: {
                              error: _vm.errors.has(
                                _vm.details.formScope + ".terms"
                              )
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "ui checkbox",
                                attrs: { id: "termsbox" }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    name: "terms",
                                    "data-vv-as": _vm.$t(
                                      "modals.newsubscriptionmodal.details.terms"
                                    ),
                                    type: "checkbox",
                                    "data-vv-scope": _vm.details.formScope
                                  },
                                  domProps: {
                                    checked: _vm.details.acceptingTerms
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.changeTermsValue()
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "modals.newsubscriptionmodal.details.agree_to"
                                      )
                                    ) + " "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          _vm.details.showTermsModal = !_vm
                                            .details.showTermsModal
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "modals.newsubscriptionmodal.details.terms"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.errors.has(_vm.details.formScope + ".terms")
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first(
                                              _vm.details.formScope + ".terms"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "two fields" },
                          [
                            _c("field", {
                              attrs: {
                                allowEdit: "",
                                scope: _vm.details.formScope,
                                field: _vm.subscriptionField,
                                multiple: "",
                                settings: {
                                  maxSelections: _vm.maxSubscriptionsSelect
                                },
                                "is-sub-field-valid":
                                  _vm.isSubscriptionValueValid,
                                "are-all-subs-chosen":
                                  _vm.areAllSubscriptionsChosen,
                                placeholder: "Select subscription(s)"
                              },
                              on: { "fake-input": _vm.changeSubscription },
                              scopedSlots: _vm._u(
                                [
                                  !_vm.safeObjectGet(
                                    _vm.selectedBooking,
                                    "hasFreeBooked"
                                  ) &&
                                  !_vm.safeObjectGet(
                                    _vm.updateBooking,
                                    "is_free"
                                  ) &&
                                  _vm.totalBookedFeePrice > 0
                                    ? {
                                        key: "subMessage",
                                        fn: function() {
                                          return [
                                            _c(
                                              "span",
                                              { staticStyle: { color: "red" } },
                                              [
                                                _vm._v(
                                                  "Selected subscriptions will increase the cost of booking by " +
                                                    _vm._s(
                                                      _vm._f("money")(
                                                        _vm.totalBookedFeePrice
                                                      )
                                                    )
                                                )
                                              ]
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    : null
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "semantic-modal",
                    {
                      attrs: {
                        settings: {
                          content_classes: { content: true },
                          closeable: false,
                          closeable_button: false
                        }
                      },
                      model: {
                        value: _vm.details.showTermsModal,
                        callback: function($$v) {
                          _vm.$set(_vm.details, "showTermsModal", $$v)
                        },
                        expression: "details.showTermsModal"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "ui header",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("modals.paymentterms.header")) +
                              "\n      "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("payment-terms"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "actions",
                          attrs: { slot: "actions" },
                          slot: "actions"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "ui deny red button",
                              on: {
                                click: function($event) {
                                  return _vm.denyTerms()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("globals.buttons.no")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ui ok green button",
                              on: {
                                click: function($event) {
                                  return _vm.acceptTerms()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("globals.buttons.accept")))]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedBooking
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.tabs[_vm.currentTab].name === "warning_message",
                      expression: "tabs[currentTab].name === 'warning_message'"
                    }
                  ],
                  staticClass: "ui active basic tab segment"
                },
                [
                  _c("div", { staticClass: "content" }, [
                    _c("h3", { staticClass: "ui header" }, [
                      _vm._v(
                        _vm._s(
                          this.$t(
                            "modals.newbookingmodal.warning_message.content.header"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ui divider" }),
                    _vm._v(" "),
                    _c("h4", { staticClass: "ui header red" }, [
                      _vm._v(_vm._s(_vm.selectedBooking.warning_message))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "ui form",
                        attrs: { "data-vv-scope": _vm.warningMessage.formScope }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: {
                              error: _vm.errors.has(
                                _vm.warningMessage.formScope + ".warning"
                              )
                            }
                          },
                          [
                            _c("div", { staticClass: "ui checkbox" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  name: "warning",
                                  "data-vv-as": this.$t(
                                    "modals.newbookingmodal.warning_message.title"
                                  ),
                                  type: "checkbox",
                                  "data-vv-scope": _vm.warningMessage.formScope
                                },
                                domProps: {
                                  checked: _vm.warningMessage.acceptingTerms
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.changeWarningAcceptValue()
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    this.$t(
                                      "modals.newbookingmodal.warning_message.content.agree"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm.errors.has(
                                _vm.warningMessage.formScope + ".warning"
                              )
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errors.first(
                                            _vm.warningMessage.formScope +
                                              ".warning"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      ]
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabs[_vm.currentTab].name === "confirm"
            ? _c("div", { staticClass: "ui active basic tab segment" }, [
                _c("div", { staticClass: "content" }, [
                  _c("div", { staticClass: "ui header" }, [
                    _c("i", { staticClass: "calendar icon" }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "modals.newbookingmodal.confirm.content.header"
                          )
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui divider" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui three column stackable grid" }, [
                    _c("div", {
                      staticClass: "two wide tablet four wide computer column"
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "twelve wide tablet eight wide computer column"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "ui segments" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "ui zw-orange inverted center aligned segment"
                              },
                              [
                                _c("div", { staticClass: "ui huge header" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.selectedBooking.product.name) +
                                      "\n              "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "ui segment" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "ui two column stackable middle aligned divided grid"
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "center aligned column" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "ui zw statistic" },
                                          [
                                            _vm.booking.selectedDate
                                              ? _c(
                                                  "h1",
                                                  {
                                                    staticClass:
                                                      "zw compact header"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            _vm.booking
                                                              .selectedDate,
                                                            "DD"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.booking.selectedDate
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "orange label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            _vm.booking
                                                              .selectedDate,
                                                            "MMMM"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "h1",
                                                  {
                                                    staticClass:
                                                      "zw compact header"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "modals.newbookingmodal.confirm.content.validation.no_date_picked"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.update
                                          ? [
                                              _c(
                                                "span",
                                                { staticClass: "text-center" },
                                                [_vm._v("-")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "ui zw statistic"
                                                },
                                                [
                                                  _vm.booking.selectedEndDate
                                                    ? _c(
                                                        "h1",
                                                        {
                                                          staticClass:
                                                            "zw compact header"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.formatDate(
                                                                  _vm.booking
                                                                    .selectedEndDate,
                                                                  "DD"
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.booking.selectedDate
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "orange label"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.formatDate(
                                                                  _vm.booking
                                                                    .selectedEndDate,
                                                                  "MMMM"
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "h1",
                                                        {
                                                          staticClass:
                                                            "zw compact header"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "modals.newbookingmodal.confirm.content.validation.no_date_picked"
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "center aligned column" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "ui zw statistic" },
                                          [
                                            _vm.booking.selectedStartTime &&
                                            _vm.booking.selectedEndTime
                                              ? _c(
                                                  "h1",
                                                  {
                                                    staticClass:
                                                      "zw compact header"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            _vm.booking
                                                              .selectedDate +
                                                              " " +
                                                              _vm.booking
                                                                .selectedStartTime,
                                                            "HH:mm"
                                                          )
                                                        ) +
                                                        " - " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            _vm.booking
                                                              .selectedDate +
                                                              " " +
                                                              _vm.booking
                                                                .selectedEndTime,
                                                            "HH:mm"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "h1",
                                                  {
                                                    staticClass:
                                                      "zw compact header"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "modals.newbookingmodal.confirm.content.validation.no_time_picked"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                            _vm._v(" "),
                                            _vm.booking.selectedStartTime &&
                                            _vm.booking.selectedEndTime
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "orange label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "modals.newbookingmodal.confirm.content.time"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ui center aligned segment" },
                              [
                                _c("div", { staticClass: "ui zw statistic" }, [
                                  _vm.booking.selectedDate
                                    ? _c(
                                        "h1",
                                        { staticClass: "zw compact header" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.formatDate(
                                                  _vm.booking.selectedDate,
                                                  "YYYY"
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _c("h1", { staticClass: "header" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "modals.newbookingmodal.confirm.content.validation.no_year_picked"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.update
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ui center aligned segment"
                                    },
                                    [
                                      _vm.requiresPayment
                                        ? _c(
                                            "div",
                                            { staticClass: "ui header" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "product-block"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "product-price"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "name" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.safeObjectGet(
                                                                _vm.updateBooking,
                                                                "booking.product.name"
                                                              )
                                                            ) + ":"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.safeObjectGet(
                                                        _vm.updateBooking,
                                                        "booking.product.apply_vat"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "price"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "money"
                                                                    )(
                                                                      _vm.totalProductPrice *
                                                                        0.8
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "price"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "money"
                                                                    )(
                                                                      _vm.totalProductPrice
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.totalBookedFeePrice > 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "product-price"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "name"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Booked FEE:"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.safeObjectGet(
                                                            _vm.updateBooking,
                                                            "booking.product.apply_vat"
                                                          )
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "price"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "money"
                                                                        )(
                                                                          _vm.totalBookedFeePrice *
                                                                            0.8
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "price"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "money"
                                                                        )(
                                                                          _vm.totalBookedFeePrice
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.hasGuest
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "product-price"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "name"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "modals.newbookingmodal.guest.price"
                                                                  )
                                                                ) + ":"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.safeObjectGet(
                                                            _vm.updateBooking,
                                                            "booking.product.apply_vat"
                                                          )
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "price"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "money"
                                                                        )(
                                                                          _vm.guestAdditionalPrice *
                                                                            0.8
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "price"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "money"
                                                                      )(
                                                                        _vm.guestAdditionalPrice
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.safeObjectGet(
                                                    _vm.updateBooking,
                                                    "booking.product.apply_vat"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "product-vat-price"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "name"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "25,00% moms:"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "price"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "money"
                                                                  )(
                                                                    _vm.vatPrice
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                  Total: " +
                                                  _vm._s(
                                                    _vm._f("money")(
                                                      _vm.totalPrice
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "ui header" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "pages.bookings.reserved_bookings.labels.free"
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.safeObjectGet(
                                    _vm.updateBooking,
                                    "startup_fee"
                                  ) === "requested" ||
                                  _vm.safeObjectGet(
                                    _vm.updateBooking,
                                    "startup_fee"
                                  ) === "completed"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ui center aligned segment"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "ui header" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "product-block"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "product-price"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "name" },
                                                        [_vm._v("Startup Fee:")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.safeObjectGet(
                                                        _vm.updateBooking,
                                                        "booking.product.apply_vat"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "price"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "money"
                                                                    )(
                                                                      _vm.safeObjectGet(
                                                                        _vm.updateBooking,
                                                                        "booking.product.fee_amount"
                                                                      ) * 0.8
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "price"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "money"
                                                                    )(
                                                                      _vm.safeObjectGet(
                                                                        _vm.updateBooking,
                                                                        "booking.product.fee_amount"
                                                                      )
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.safeObjectGet(
                                                    _vm.updateBooking,
                                                    "booking.product.apply_vat"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "product-vat-price"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "name"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "25,00% moms:"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "price"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "money"
                                                                  )(
                                                                    _vm.safeObjectGet(
                                                                      _vm.updateBooking,
                                                                      "booking.product.fee_amount"
                                                                    ) -
                                                                      _vm.safeObjectGet(
                                                                        _vm.updateBooking,
                                                                        "booking.product.fee_amount"
                                                                      ) *
                                                                        0.8
                                                                  )
                                                                ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ui center aligned segment"
                                    },
                                    [
                                      _vm.requiresPayment
                                        ? _c(
                                            "div",
                                            { staticClass: "ui header" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "product-block"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "product-price"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "name" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.safeObjectGet(
                                                                _vm.selectedBooking,
                                                                "product.name"
                                                              )
                                                            ) + ":"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.safeObjectGet(
                                                        _vm.selectedBooking,
                                                        "product.apply_vat"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "price"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "money"
                                                                    )(
                                                                      _vm.totalProductPrice *
                                                                        0.8
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "price"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "money"
                                                                    )(
                                                                      _vm.totalProductPrice
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.totalBookedFeePrice > 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "product-price"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "name"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Booked FEE:"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.safeObjectGet(
                                                            _vm.selectedBooking,
                                                            "product.apply_vat"
                                                          )
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "price"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "money"
                                                                        )(
                                                                          _vm.totalBookedFeePrice *
                                                                            0.8
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "price"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "money"
                                                                        )(
                                                                          _vm.totalBookedFeePrice
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.hasGuest
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "product-price"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "name"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "modals.newbookingmodal.guest.price"
                                                                  )
                                                                ) + ":"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.safeObjectGet(
                                                            _vm.selectedBooking,
                                                            "product.apply_vat"
                                                          )
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "price"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "money"
                                                                        )(
                                                                          _vm.guestAdditionalPrice *
                                                                            0.8
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "price"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "money"
                                                                      )(
                                                                        _vm.guestAdditionalPrice
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.safeObjectGet(
                                                    _vm.selectedBooking,
                                                    "product.apply_vat"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "product-vat-price"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "name"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "25,00% moms:"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "price"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "money"
                                                                  )(
                                                                    _vm.vatPrice
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                  Total: " +
                                                  _vm._s(
                                                    _vm._f("money")(
                                                      _vm.totalPrice
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "ui header" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "pages.bookings.reserved_bookings.labels.free"
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                    ]
                                  )
                                ]
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "two wide tablet four wide computer column"
                    })
                  ]),
                  _vm._v(" "),
                  _vm.booking.selectedStartTime !== null &&
                  _vm.booking.selectedEndTime !== null
                    ? _c("div", { staticClass: "ui grid" }, [
                        _c("span", { staticClass: "ui header" }, [
                          _vm._v(
                            _vm._s(_vm.$t("modals.booking.booking_time_notice"))
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.tabs[_vm.currentTab].name === "payment_method"
            ? _c("div", { staticClass: "ui active basic tab segment" }, [
                _c("div", { staticClass: "content" }, [
                  _c("h3", { staticClass: "ui header" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "modals.newsubscriptionmodal.payment_method.description"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isDefaultPaymentMethod && _vm.paymentMethods.length > 0
                    ? _c("p", { staticClass: "text-info text-danger" }, [
                        _vm._v(
                          "\n        * " +
                            _vm._s(
                              _vm.$t(
                                "modals.newsubscriptionmodal.payment_method.default_payment_method"
                              )
                            ) +
                            "\n      "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui divider" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ui zw two flex-center stackable cards" },
                    [
                      _vm.paymentMethods.length > 0
                        ? _vm._l(_vm.paymentMethods, function(paymentMethod) {
                            return _c("payment-method", {
                              key: paymentMethod.id,
                              attrs: {
                                id: paymentMethod.id,
                                name: paymentMethod.name,
                                slug: paymentMethod.slug,
                                active:
                                  _vm.selectedPaymentMethod ===
                                  paymentMethod.slug,
                                editable: !_vm.isDefaultPaymentMethod,
                                "payment-plan": "instant"
                              },
                              on: {
                                select: _vm.selectPaymentMethod,
                                deselect: _vm.deselectPaymentMethod
                              }
                            })
                          })
                        : [
                            _c(
                              "b",
                              {
                                staticClass: "text-center",
                                staticStyle: {
                                  "font-size": "20px",
                                  margin: "20px 0"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "globals.validation.warning.not_all_steps_completed",
                                      { 0: _vm.$t("globals.container.booked") }
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.requiresPayment ||
                  _vm.safeObjectGet(_vm.updateBooking, "startup_fee") ===
                    "requested"
                    ? _c("div", [
                        _vm.selectedPaymentMethod === "nets"
                          ? _c("div", { staticClass: "ui divider notice" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("modals.nets_notice")) +
                                  "\n        "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedPaymentMethod === "vipps"
                          ? _c("div", { staticClass: "ui divider notice" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t("modals.booking.vipps_notice")
                                  ) +
                                  "\n        "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "actions",
              staticStyle: { "margin-bottom": "1rem" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "ui red button",
                  on: {
                    click: function($event) {
                      return _vm.closeModal()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("globals.buttons.cancel")) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.showPrevious
                ? _c(
                    "div",
                    {
                      staticClass: "ui primary prev button",
                      on: {
                        click: function($event) {
                          return _vm.prevTab()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("globals.buttons.previous")) +
                          "\n    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showNext
                ? _c(
                    "div",
                    {
                      staticClass: "ui primary zw next button",
                      on: {
                        click: function($event) {
                          return _vm.nextTab()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("globals.buttons.next")) +
                          "\n    "
                      )
                    ]
                  )
                : !_vm.showNext
                ? [
                    _vm.update &&
                    !_vm.requiresPayment &&
                    _vm.safeObjectGet(_vm.updateBooking, "startup_fee") !==
                      "requested"
                      ? _c(
                          "div",
                          {
                            staticClass: "ui button green",
                            class: [
                              { "loading disabled": _vm.buttonLoader },
                              { disabled: _vm.isActivateButtonDisabled }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.activateBooking()
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("globals.buttons.activate")))
                            ])
                          ]
                        )
                      : !_vm.update && !_vm.requiresPayment
                      ? _c(
                          "div",
                          {
                            staticClass: "ui button green",
                            class: [
                              { "loading disabled": _vm.buttonLoader },
                              { disabled: _vm.isActivateButtonDisabled }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.activateBooking()
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("globals.buttons.activate")))
                            ])
                          ]
                        )
                      : _vm.selectedPaymentMethod === "vipps"
                      ? _c("vipps-mobilepay-button", {
                          attrs: {
                            type: "button",
                            brand: "vipps",
                            language: _vm.getLanguage,
                            variant: "primary",
                            rounded: "false",
                            verb: "pay",
                            stretched: _vm.isMobile,
                            branded: "true",
                            disabled: _vm.isActivateButtonDisabled,
                            loading: _vm.buttonLoader
                          },
                          on: {
                            click: function($event) {
                              return _vm.activateBooking()
                            }
                          }
                        })
                      : _c(
                          "div",
                          {
                            staticClass: "ui button green",
                            class: [
                              { "loading disabled": _vm.buttonLoader },
                              { disabled: _vm.isActivateButtonDisabled }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.activateBooking()
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("globals.buttons.finish")))
                            ])
                          ]
                        )
                  ]
                : _vm._e()
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "guest-option__icon" }, [
      _c("i", { staticClass: "users icon" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-149a29da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-149a29da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/booking/NewBookingModal.vue
// module id = t9tZ
// module chunks = 1